// @flow

import * as React from 'react';
import { Tooltip } from '../../common/components/core';
import classNames from 'classnames';

const IMAGE_PATH = '/static/images/editor/ic_ribbonStar.svg';
const TOOLTIP_PREMIUM_TEXT = 'This feature is part of the premium package.';

type Props = {
  /**
   * If true, a tooltip will show on hover of the premium ribbon icon,
   * and show TOOLTIP_PREMIUM_TEXT.
   */
  actAsTooltip?: boolean,
  /**
   * If true, premium ribbon will not show.
   */
  hide?: boolean,
  /**
   * applied to outermost span
   */
  className?: string
};

export default class PremiumRibbon extends React.PureComponent<Props> {
  render() {
    const ribbon = <img src={IMAGE_PATH} />;

    if (this.props.hide) {
      return null;
    }

    return (
      <span
        className={classNames('premium-ribbon', this.props.className)}
        data-testid="premium-ribbon"
      >
        {this.props.actAsTooltip ? (
          <Tooltip title={TOOLTIP_PREMIUM_TEXT}>{ribbon}</Tooltip>
        ) : (
          ribbon
        )}
      </span>
    );
  }
}
